var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPicture4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 27,
    height: 27,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAMAAAC6CgRnAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFQUExURQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACQ9i7QAAABvdFJOUwABAgMEBgcIDA8QERITFRgZHB4iIyQlJicoKSssLS8yMzQ5PT9ARU5WWFpeYm1vd3l7fX+BgoeJipiZnqSsrq+xsra4ubq+wMHExsfJy8zNz9HT1NXW19na29ze4Ofp6+zv8PP09fb3+Pn6+/z9/ubtWFcAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEiSURBVChThZFXVwIxFAYvIqgoVkDdXQsWFBSsiL2AvaEiIGIBQVEp+f9vBvLtZj3HMg8pM083oX+xevpsONZxqg6cOO2XFxGvxdqjaG4HOWe30yEEjsoYy2zsnV0n4oeb0VfGdhA4Xt6+EUPgdJfgdNYQODMVOJ3TThTqeIAyqC4hkf8DSnLQirZchZFc9aOF/2jBMozkpAtt/A1GsoVE9gSMwXsQiWgayuC4DYX/w9wnpCCuINh9o000GXsuNKasFV9Si8YX2Rby83zr9Wfrrbw+3CK8IFQI8HVMTLIrnE7zeS48FThqJJZ0wQJfqZIv1kTLDEHqTERzj09oGpyZVdHufmoRNBV3Myv36dTtTXJ/BHcTFpemKsrggEc+168QfQFR9osgN1MnygAAAABJRU5ErkJggg==",
    preserveAspectRatio: "none",
    id: "img0"
  }), /*#__PURE__*/React.createElement("pattern", {
    width: 27,
    height: 27,
    patternUnits: "userSpaceOnUse",
    id: "pattern1",
    overflow: "hidden",
    patternTransform: "matrix(0.986707 0 0 0.986707 8.8947 8.3252)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.8612 21.6459C43.8612 33.6006 34.17 43.2918 22.2153 43.2918 10.2606 43.2918 0.569398 33.6006 0.569398 21.6459 0.569398 9.6912 10.2606 7.26318e-07 22.2153 7.26318e-07 34.17 7.26318e-07 43.8612 9.6912 43.8612 21.6459Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8947 8.3252 35.5358 8.3252 35.5358 34.9663 8.8947 34.9663Z",
    fill: "url(#pattern1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture4);
export default __webpack_public_path__ + "static/media/Picture4.731129c7670ef4efc444de713ce5bb73.svg";
export { ForwardRef as ReactComponent };